import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EVENT_SEVERITY, PANEL_SCROLL_THRESHOLD } from '../Model/Model';

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Expand / collapse of a group of the overview panel and the badges of its counters. Expanding the
 * group reads the events of its area, and scrolling its list to the bottom reads the next page.
 */
const GroupedCardApp = ({ group, onLoadMore }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);
    const listRef = useRef(null);
    const { feed } = group;

    const badges = [
        { key: 'critical', total: group?.critical, legend: 'x_critical', severity: EVENT_SEVERITY.CRITICAL },
        { key: 'warning', total: group?.warning, legend: 'x_warning', severity: EVENT_SEVERITY.WARNING },
    ].filter((badge) => badge.total > 0);

    const toggleExpanded = () => setExpanded((prev) => !prev);

    /**
     * Reads the next page of the area once its list is near its bottom. A list whose events do not
     * fill it has no scroll, so it reads the next page right away.
     */
    const loadMoreIfNeeded = () => {
        const list = listRef.current;
        if (!expanded || feed.loading || (feed.loaded && !feed.hasMore)) return;
        if (!feed.loaded) return onLoadMore();
        if (!list) return;

        const { scrollTop, scrollHeight, clientHeight } = list;
        if (scrollHeight - scrollTop <= clientHeight + PANEL_SCROLL_THRESHOLD) onLoadMore();
    };

    // Expanding reads the first page, and each page can leave the list without scroll //
    useEffect(loadMoreIfNeeded, [expanded, feed]);

    return {
        t,
        expanded,
        toggleExpanded,
        badges,
        feed,
        listRef,
        loadMoreIfNeeded
    };
};

export default GroupedCardApp;
